import { Box, Skeleton, Text } from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import { VerifyListing } from './verify-listing'
import { BoostListing } from './boost-listing'
import { PriceInsight } from './price-insight'
import { useListingData } from '../../context/listing-data'

export const Insights = () => {
  const { t } = useTranslation()
  const { loading } = useListingData()

  return (
    <Box display="flex" flexDirection="column" gap="gutter" data={{ testid: 'insights-section' }}>
      {loading ? <Skeleton.Header /> : <Text weight="strong">{t('Insights')}</Text>}

      <Box borderTop="borderNeutralLight">
        <VerifyListing />
        <BoostListing />
        <PriceInsight />
      </Box>
    </Box>
  )
}
